import { useParams, Navigate } from "react-router-dom";
import UseCasePage from "./UseCasePage";

const VALID = new Set(["webinars", "education", "sports"]);

export default function UseCaseRoute() {
  const { slug } = useParams();
  if (!VALID.has(slug)) return <Navigate to="/" replace />;
  return <UseCasePage slug={slug} />;
}
